import * as Yup from 'yup';

export const createQuestionSchema = Yup.object().shape({
  title: Yup.object().shape({
    uz: Yup.string().required('Savol (uz) majburiy'),
    ru: Yup.string().required('Savol (ru) majburiy'),
    en: Yup.string().required('Savol (en) majburiy'),
  }),
  description: Yup.object().shape({
    uz: Yup.string().required('Javob (uz) majburiy'),
    ru: Yup.string().required('Javob (ru) majburiy'),
    en: Yup.string().required('Javob (en) majburiy'),
  }),
  category: Yup.string().required('Kategoriya majburiy'),
});


export const createQuestionCategorySchema = Yup.object().shape({
  name: Yup.object().shape({
    uz: Yup.string().required('Tur nomi (uz) majburiy'),
    ru: Yup.string().required('Tur nomi (ru) majburiy'),
    en: Yup.string().required('Tur nomi (en) majburiy'),
  }),
  image: Yup.mixed().nullable(),
});